import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ReferenceDataCategoriesConstants } from '../../../lib/constants/reference-data-categories';
import { ReferenceDataConstants } from '../../../lib/constants/reference-data-constants';
import { ReferenceDataService } from '../../../lib/services/reference-data.service';

import { BaseEligibilityQuestionsComponent } from '../base-eligibility-questions.component';

@Component({
  selector: 'boi-buy-to-let-questions',
  templateUrl: './buy-to-let-questions.component.html',
  styleUrls: ['./buy-to-let-questions.component.scss']
})
export class BuyToLetQuestionsComponent extends BaseEligibilityQuestionsComponent implements OnInit {
  public sectionOneEnd: number;

  @Input() public interestOnly: string;
  @Input() public interestOnlyValidAssets: string;
  @Input() public showDescription = true;

  @Output() public readonly interestOnlyChange = new EventEmitter<string>();
  @Output() public readonly interestOnlyValidAssetsChange = new EventEmitter<string>();

  constructor(private readonly referenceDataService: ReferenceDataService) {
    super();
  }

  public ngOnInit(): void {
    super.ngOnInit();

    this.sectionOneEnd = +this.referenceDataService.getConfigurationValue(
      ReferenceDataCategoriesConstants.CLIENT_ENVIRONMENT_CATEGORY,
      ReferenceDataConstants.BuyToLetDynamicSectionOneEnd
    );
  }

  public changeInterestOnly(interestOnly: string): void {
    this.interestOnly = interestOnly;
    this.interestOnlyChange.emit(interestOnly);
    this.isValidChange.emit(this.checkValidity());
  }

  public changeInterestOnlyValidAssets(interestOnlyValidAssets: string): void {
    this.interestOnlyValidAssets = interestOnlyValidAssets;
    this.interestOnlyValidAssetsChange.emit(interestOnlyValidAssets);
    this.isValidChange.emit(this.checkValidity());
  }

  public checkValidity(): boolean {
    for (const question of this.questions) {
      if (!question.ProvidedAnswer) {
        return false;
      }
    }

    if (
      !this.caseSetup.PropertyLocation ||
      !this.interestOnly ||
      (this.interestOnly === this.referenceDataOptionLists.AnswerTypeYes && !this.interestOnlyValidAssets)
    ) {
      return false;
    }

    return true;
  }
}
